import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Button from 'UIKit/Button'
import Link from 'UIKit/Link'
import Text from 'UIKit/Text'
import { RouteConfig } from 'config/constants/route'
import { UserBonus } from 'config/types/bonus/userBonus'
import { Fragment } from 'react'
import { Trans } from 'react-i18next'
import { useActiveBoosterWagerBonus, useActiveLevelUpBonus } from 'state/bonus/hooks'
import { Icons } from 'svgs'
import theme from 'theme'
import BonusTooltipItem from './BonusTooltipItem'
import BoosterInUsedTooltipSection from './components/BoosterInUsedTooltipSection'

const BONUSES_RENDER_TOOLTIP = 3

const BonusCenterTooltipContent = ({ bonuses }: { bonuses: UserBonus[] }) => {
  const isLevelUpBonusActive = useActiveLevelUpBonus()
  const isBoosterWagerBonusActive = useActiveBoosterWagerBonus()
  const bonusesInTooltip = bonuses
    .filter((item) => item !== isBoosterWagerBonusActive && item !== isLevelUpBonusActive)
    .slice(0, BONUSES_RENDER_TOOLTIP)

  return (
    <Box
      width="320px"
      background={{ background: theme.colors.cardBackground }}
      padding="20px"
      zIndex={10}
      position="relative"
      borderRadius={theme.radii.small}
    >
      {(isLevelUpBonusActive || isBoosterWagerBonusActive) && (
        <>
          <Text mb="8px" fontSize="16px" fontWeight={700} lineHeight="normal" letterSpacing="-0.32px">
            <Trans>Booster In Use</Trans>
          </Text>

          {isBoosterWagerBonusActive && (
            <Box>
              <BoosterInUsedTooltipSection
                bonus={isBoosterWagerBonusActive}
                image="/images/bonusCenter/boost-wager-no-color-icon.png"
              />
            </Box>
          )}

          {isLevelUpBonusActive && isBoosterWagerBonusActive && <Box my="8px" height="1px" background="#1D2533" />}

          {isLevelUpBonusActive && (
            <Box>
              <BoosterInUsedTooltipSection bonus={isLevelUpBonusActive} image="/images/bonusCenter/cup-icon.png" />
            </Box>
          )}

          {!!bonusesInTooltip.length && <Box my="12px" height="2px" background="#1D2533" />}
        </>
      )}

      {!!bonusesInTooltip.length && (
        <>
          <Text mb="12px" fontSize="16px" fontWeight={700} lineHeight="normal" letterSpacing="-0.32px">
            <Trans>Available Bonuses</Trans>
          </Text>
          {bonusesInTooltip.map((item: UserBonus, index: number) => (
            <Fragment key={item.id}>
              <BonusTooltipItem bonus={item} />
              {index < bonusesInTooltip.length - 1 && <Box my="12px" height="1px" background="#1D2533" />}
            </Fragment>
          ))}
        </>
      )}

      {bonuses.length > BONUSES_RENDER_TOOLTIP && (
        <Button width="100%" height="32px" mt="12px" style={{ background: 'rgba(255, 255, 255, 0.08)' }}>
          <Flex alignItems="center" justifyContent="space-between" as={Link} href={RouteConfig.BonusCenter}>
            <Text marginRight="4px" letterSpacing="-0.24px" fontSize="12px" fontWeight="600">
              <Trans>View all Bonuses</Trans>
            </Text>
            <Icons.ArrowRight width="12px" fill="#E0E0E0" />
          </Flex>
        </Button>
      )}
    </Box>
  )
}

export default BonusCenterTooltipContent
